// Etapa do fluxo em que a fatura está, pelo `status_fatura` — é o que decide qual modal abre.
//
// Mesma régua de Faturas e Cobranças (FinanceiroLayout: handleCardClick e os `isOpen` dos modais).
// Existe aqui para as telas que abrem o mesmo fluxo por outro caminho (Agrupamentos de
// Faturamento) não precisarem adivinhar a etapa: abrir sempre o cálculo mostrava a fatura já
// calculada como se ainda faltasse calcular.

export type EtapaFluxoFatura = 'validacao' | 'calculo' | 'emissao' | 'emitido' | 'enviada';

/** Etapa da fatura, ou null quando o status não tem tela no fluxo (placeholder, cancelada, excluída...). */
export function etapaDaFatura(status: string | null | undefined): EtapaFluxoFatura | null {
  const s = (status ?? '').trim();
  if (!s || s === 'Fatura disponível' || s === 'Aguardando validação') return 'validacao';
  if (s === 'Fatura validada') return 'calculo';
  if (s === 'Com boleto calculado') return 'emissao';
  if (s === 'Com boleto emitido / A enviar') return 'emitido';
  if (s === 'Cobrança enviada') return 'enviada';
  return null;
}

/** O que o clique abre em cada etapa — texto da dica do botão. */
export const ROTULO_ETAPA_FLUXO: Record<EtapaFluxoFatura, string> = {
  validacao: 'validação da fatura',
  calculo: 'cálculo do boleto',
  emissao: 'cálculo pronto (emissão)',
  emitido: 'boleto emitido, a enviar',
  enviada: 'cobrança enviada',
};
